@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.rides.RideRouteDto

object GetRideRouteEndpoint : EndPoint<GetRideRouteEndpoint.Request, GetRideRouteEndpoint.Response>() {
    class Request(
        val originLat: Double,
        val originLng: Double,
        val destLat: Double,
        val destLng: Double,
    )

    class Response(
        val route: RideRouteDto?,
    )
}